import { CommandeBC, LienComplementBC } from '../types';

// Commandes complementaires cote PRESTATAIRE : regles pures, sans React.

/** Statut d'une commande que l'acheteur prepare encore : le titulaire n'y a pas acces. */
const BROUILLON_ACHETEUR = 1;

/**
 * Statut affiche au titulaire pour un bon lie : celui de SA commande dedans. Un brouillon acheteur
 * (l'acheteur prepare encore le bon) se lit « Brouillon », sans plus de detail sur ce qu'il fait.
 */
const statutTitulaire = (ligne: LienComplementBC): string => {
  const commande = ligne.commande_titulaire;
  if (!commande) return '-';
  if (commande.id_status === BROUILLON_ACHETEUR) return 'Brouillon';
  return commande.statut || '-';
};

const avecStatut = (ligne: LienComplementBC): LienComplementBC => ({ ...ligne, statut: statutTitulaire(ligne) });

/**
 * Lignes du tableau : la principale en premier (l'operation de la page, ou sa parente depuis un
 * complement), puis ses complements. Chaque ligne porte la commande du titulaire dans ce bon et le
 * libelle de statut a afficher.
 */
export const lignesComplements = (commande: CommandeBC): LienComplementBC[] => {
  const operation = commande.operation;
  if (!operation?.id) return [];
  if (!operation.id_operation_parente) {
    const principale: LienComplementBC = {
      id: operation.id,
      numero: operation.numero,
      nom: operation.nom,
      createur: operation.createur,
      cree_par: operation.cree_par,
      prix_total: operation.prix_total,
      created_at: operation.created_at,
      commande_titulaire: {
        id: commande.id,
        id_status: commande.id_status ?? BROUILLON_ACHETEUR,
        statut: commande.status?.nom,
      },
    };
    return [principale, ...(operation.complementaires ?? [])].map(avecStatut);
  }
  const parente = operation.parente;
  return parente ? [parente, ...(parente.complementaires ?? [])].map(avecStatut) : [];
};

/**
 * Le titulaire ouvre un bon lie seulement si sa commande y existe et a quitte le brouillon acheteur :
 * avant, l'acheteur ne lui a encore rien envoye (ni lancement, ni transfert).
 */
export const estOuvrable = (ligne: LienComplementBC): boolean =>
  !!ligne.commande_titulaire && ligne.commande_titulaire.id_status !== BROUILLON_ACHETEUR;

/**
 * Libelle du champ « Type de commande » du descriptif : la base porte 'initial' sur un bon classique
 * et « Complémentaire N°X au <numero de la principale> » sur un complement.
 */
export const libelleTypeCommande = (typeCommande?: string | null): string =>
  !typeCommande || typeCommande === 'initial' ? 'Initiale' : typeCommande;
